import dayjs from "dayjs";

import { parseUnixTimestamp } from "@/lib/dateUtils";

/** Kickoff: Typesense gives int64 seconds, GET /{id} an ISO string. */
export function formatKickoff(raw: string | number | null | undefined): string {
  if (raw === undefined || raw === null || raw === "") return "—";
  const d = typeof raw === "number" ? parseUnixTimestamp(raw) : dayjs(raw);
  return d.isValid() ? d.format("DD/MM/YYYY HH:mm") : "—";
}

/** "2–1", or a dash until the match has a score. */
export function formatScore(
  home: number | null | undefined,
  away: number | null | undefined,
): string {
  return home == null || away == null ? "—" : `${home}–${away}`;
}
